import { useQuery } from '@tanstack/react-query';

import { clientAxios } from '@/shared/api';
import { convertAuthorItem } from '@/shared/utils';
import { AuthorListQueryParams } from '@/shared/types';

const useAuthorSearchQuery = ({
  query,
}: Pick<AuthorListQueryParams, 'query'>) => {
  return useQuery({
    queryKey: ['authorSearchApi', query],
    queryFn: async () => {
      const { data } = await clientAxios.get('/authorSearchApi/', {
        params: { query },
      });
      return {
        count: data.data.length,
        authors: convertAuthorItem(data.data),
      };
    },
  });
};

export default useAuthorSearchQuery;
